import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import marked from "marked";

import MarkdownRenderer from '../../components/MarkdownRenderer';
import ExampleList from '../../components/ExampleList';

class Typography extends Component {

    constructor(props) {
        super(props);

        this.state = {
            markdown: ''
        }

        this.props.includeNav();
    }

    // componentWillMount() {
    //
    //     fetch(require("./index.md"))
    //         .then(response => {
    //             return response.text()
    //         })
    //         .then(text => {
    //             this.setState({
    //                 markdown: marked(text)
    //             })
    //         })
    // }

    render() {

        const sizeClasses = [
          {
            text: 'XXS font size',
            markdown : '`.font-xxs`'
          },{
            text: 'XS font size',
            markdown : '`.font-xs`'
          },{
            text: 'SM font size',
            markdown : '`.font-sm`'
          },{
            text: 'MD font size',
            markdown : '`.font-md`'
          },{
            text: 'LG font size',
            markdown : '`.font-lg`'
          },{
            text: 'XL font size',
            markdown : '`.font-xl`'
          },{
            text: 'XXL font size',
            markdown : '`.font-xxl`'
          }
        ]

        const weightClasses = [
          {
            text: 'Regular font weight',
            markdown : '`.text-regular`',
            helper: 'default on most elements including body copy'
          },{
            text: 'Light font weight',
            markdown : '`.text-light`'
          },{
            text: 'Bold font weight',
            markdown : '`.text-bold`'
          },{
            text: 'Extra bold font weight',
            markdown : '`.text-extra-bold`'
          },
          {
            text: '*Regular font weight and standard line height',
            markdown : '`.base-text`'
          }
        ]

        const treatmentClasses = [
          {
            text: 'Italics',
            markdown : '`.text-italic`'
          },{
            text: 'Underline',
            markdown : '`.text-underline`'
          },{
            text: 'No Underline',
            markdown : '`.no-underline`',
            helper: 'Removes any underline or border-based underline'
          },{
            text: 'Text Link',
            markdown : '`.text-link`',
            helper: 'Includes hover and focus states. Border based underline is applied. Cursor becomes pointer'
          },{
            text: 'Truncate',
            markdown: '`.truncate`',
            helper: 'will truncate a line of text with ellipsis applied to the end of the line'
          }
        ]

        const colorClasses = [
          {
            text: 'Primary Color',
            markdown: '`.text-primary`',
            helper: 'Uses the primary color applied to body'
          },{
            text: 'Secondary Color',
            markdown: '`.text-secondary`'
          },{
            text: 'Informational Text Color',
            markdown: '`.text-info`'
          },{
            text: 'Error Text Color',
            markdown: '`.text-error`'
          },{
            text: 'Success Text Color',
            markdown: '`.text-success`'
          },{
            text: 'Warning Text Color',
            markdown: '`.text-warn`'
          },{
            text: 'Text White',
            markdown: '`.text-white`'
          },{
            text: 'Text Black',
            markdown: '`.text-black`'
          },{
            text: 'Text Grey',
            markdown: '`.text-grey`'
          },{
            text: 'Text Slate',
            markdown: '`.text-slate`'
          },{
            text: 'Text Blue',
            markdown: '`.text-blue`'
          },{
            text: 'Text Green',
            markdown: '`.text-green`'
          },{
            text: 'Text Yellow',
            markdown: '`.text-yellow`'
          },{
            text: 'Text Orange',
            markdown: '`.text-orange`'
          },{
            text: 'Text Red',
            markdown: '`.text-red`'
          },{
            text: 'Text Purple',
            markdown: '`.text-purple`'
          }
        ]

        const hierarchyClasses = [
          {
            text: 'H1 Level Headline',
            markdown: '`.headline`'
          },{
            text: 'H2 Level Headline',
            markdown: '`.headline-two`'
          },{
            text: 'H3 Level Headline',
            markdown: '`.headline-three`'
          },{
            text: 'Title',
            markdown: '`.title`',
            helper: 'Basically, H4 level headline'
          },{
            text: 'Bulleted List',
            markdown: '`.bulleted`',
            helper: 'Applied to unordered lists, gives list items bullets (NOT applied to unordered lists by default)'
          },{
            text: 'Ordered List',
            markdown: '`.bulleted`',
            helper: 'Applied to lists, gives list items numbers (applied to ordered lists by default)'
          }
        ]

        const alignmentClasses = [
          {
            text: 'Align Left',
            markdown: '`.text-left`'
          },{
            text: 'Align Right',
            markdown: '`.text-right`'
          },{
            text: 'Align Center',
            markdown: '`.text-center`'
          }
        ]

        return (
            <DocumentTitle title={'BCS Documentation - Typography'}>
                <section className="page" data-component="typography">
                    <div className="row">
                        <div className="col-xs-12 col-gutter-lr border-bottom">
                            <h1>Typography</h1>
                            <p>When BCS-Next-Styles is installed, common typographical elements will be styled appropriately when used in HTML. Things like font family, font size, line height, etc will automatically match our style guide.</p>
                            <p>Type can also be customized using built-in utility classes.</p>
                        </div>
                        <div className="col-xs-12 border-bottom">
                            <div class="card">
                                <h1>H1 Headline</h1>
                                <h2>H2 Headline</h2>
                                <h3>H3 Headline</h3>
                                <h4>Title (H4 Headline)</h4>
                                <p>Not a sunrise but a galaxyrise vanquish the impossible? <strong>Decipherment</strong> the carbon in our <span>hearts of the stars</span>, apple pies, at the edge of forever the carbon in our apple pies? Star stuff harvesting star light science <em>not a sunrise</em> but a galaxyrise. Another world, galaxies <a href="/">globular</a> star cluster, gathered by gravity descended from astronomers cosmic ocean rich in heavy atoms at the edge of forever.</p>
                                <ul className="bulleted">
                                    <li>Item 1</li>
                                    <li>Item 2</li>
                                    <li><a href="/">Item 3</a></li>
                                    <li>Item 4</li>
                                </ul>
                                <p>Galaxies <strong>laws of physics</strong> cosmic fugue science how far away of brilliant syntheses, venture. <em>Rogue</em>.</p>
                                    <ol>
                                    <li>Item 1</li>
                                    <li>Item 2</li>
                                    <li><a href="/">Item 3</a></li>
                                    <li>Item 4</li>
                                </ol>
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <h2>Typography Classes</h2>
                            <p>Font size and alignment classes support breakpoint extensions for responsive usage. Remember, all breakpoints are defined mobile first. Appending a breakpoint extension will apply a style to that breakpoint and up in browser width.</p>
                            <p>Append one of the following breakpoint extensions to the end of the class name in order to specify a breakpoint range:</p>
                            <p>
                              <MarkdownRenderer text={'`-xs`'} inline={true}/>
                              <MarkdownRenderer text={'`-sm`'} inline={true}/>
                              <MarkdownRenderer text={'`-md`'} inline={true}/>
                              <MarkdownRenderer text={'`-lg`'} inline={true}/>
                              <MarkdownRenderer text={'`-xl`'} inline={true}/>
                            </p>
                            <p>Example: <MarkdownRenderer text={'`font-sm-xs font-lg-md text-center-xs text-left-md`'} inline={true}/></p>
                            <ExampleList title="Font Sizes" list={sizeClasses} body="Font sizes support breakpoint extensions."/>
                            <ExampleList title="Font Weights" list={weightClasses}/>
                            <ExampleList title="Text Treatments" list={treatmentClasses}/>
                            <ExampleList title="Color Treatments" list={colorClasses}/>
                            <ExampleList title="Implied Hierarchy" list={hierarchyClasses} body="Accessibility standards require that headline elements only be used in the correct semantic context within a document. When you want to style something to look like a headline or title without using the HTML element use one of these implied hierarchy classes."/>
                            <ExampleList title="Alignments" list={alignmentClasses} body="Alignments support breakpoint extensions."/>
                            {/*<h3>Typography Classes</h3>
                            <MarkdownRenderer text={this.state.markdown}/>*/}
                        </div>
                    </div>
                </section>
            </DocumentTitle>
        )
    }
}

export default Typography;



// WEBPACK FOOTER //
// ./src/pages/Typography/index.js